import * as React from "react";
import { Dialog, DialogProps } from "@progress/kendo-react-dialogs";

export const CustomDialog = (props: DialogProps) => {
  return <Dialog  {...props} title={"Appointment"} />;

// return <Dialog height={"100vh"} >
//   {props.children}
//   <fieldset>
//                         <div style={{ display: "flex", flexDirection: "column", marginTop: "3em" }}>
//                           <button type='submit' className='form__edit__button accept' style={{ width: "100%" }}>
//                             Amend event
//                           </button>
//                           <button onClick={() => false} className='form__edit__button reject' style={{ width: "100%" }}>
//                             Cancel
//                           </button>
//                         </div>
//                       </fieldset>

//         </Dialog>


};
